<div class="d-flex w-100 justify-content-between">
    <h2 mat-dialog-title>
        Fout bij het uploaden
    </h2>
    <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div>
        Het uploaden van de afbeelding is mislukt.
    </div>
    <div class="mt-3">
        Foutmelding: ({{data.error.status}}) {{data.error.message}}
    </div>
    <div class="d-flex align-items-center flex-column mt-3">
        <img [src]="image" [alt]="data.file.name">
        <button class="mt-2" mat-stroked-button type="button" mat-dialog-close (click)="download()">Opslaan op apparaat</button>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="justify-content-between">
    <button mat-button type="button" mat-dialog-close (click)="cancel()">Annuleren</button>
    <button mat-raised-button color="primary" type="button" (click)="retry()">Opnieuw proberen</button>
</mat-dialog-actions>
